module.exports = __webpack_public_path__ + "static/media/wise-marine-logo-white.4ab6a5bc.svg";